
import { useState } from "react";
import { UnavailableSlotsMap, UnavailableTimeSlot } from "./types";

export const useUnavailableSlots = (initialSlots: UnavailableSlotsMap = {}) => {
  const [unavailableSlots, setUnavailableSlots] = useState<UnavailableSlotsMap>(initialSlots);

  const addUnavailableSlot = (day: string, slot: UnavailableTimeSlot) => {
    setUnavailableSlots(prev => {
      const daySlots = { ...(prev || {}) };
      if (!daySlots[day]) {
        daySlots[day] = [];
      }
      
      // Verifica se lo slot è già presente
      const isSlotExists = daySlots[day].some(
        existingSlot => existingSlot.start === slot.start && existingSlot.end === slot.end
      );
      
      if (!isSlotExists) {
        daySlots[day] = [...daySlots[day], slot];
      }
      
      return daySlots;
    });
  };
  
  const removeUnavailableSlot = (day: string, index: number) => {
    setUnavailableSlots(prev => {
      const daySlots = { ...(prev || {}) };
      if (daySlots[day] && daySlots[day].length > index) {
        daySlots[day] = daySlots[day].filter((_, i) => i !== index);
        
        // Se l'array è vuoto, rimuovi la chiave
        if (daySlots[day].length === 0) {
          delete daySlots[day];
        }
      }
      
      return daySlots;
    });
  };
  
  const clearUnavailableSlots = (day?: string) => {
    setUnavailableSlots(prev => {
      if (!day) {
        // Cancella tutti gli slot non disponibili
        return {};
      }
      
      // Cancella solo gli slot del giorno specificato
      const daySlots = { ...(prev || {}) };
      delete daySlots[day];
      
      return daySlots;
    });
  };
  
  const isTimeSlotUnavailable = (day: number, hour: number): boolean => {
    const dayStr = day.toString();
    
    if (!unavailableSlots || !unavailableSlots[dayStr]) {
      return false;
    }
    
    return unavailableSlots[dayStr].some(
      slot => hour >= slot.start && hour < slot.end
    );
  };

  return {
    unavailableSlots,
    setUnavailableSlots,
    addUnavailableSlot,
    removeUnavailableSlot,
    clearUnavailableSlots,
    isTimeSlotUnavailable
  };
};
